

// import React, { useEffect, useState } from "react";
// import fundwalelogo from "../../assets/images/Fundswalle_Logo.png"
// const ProcessingPage = ({ setScreen }) => {
//   const [ready, setReady] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setReady(true);
//     }, 3000);

//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <section className="fw-screen fw-screen--processing-new fw-fade">
//            <div className="fw-brandmain2">
//           <img 
//             src={fundwalelogo} 
//             alt="Fundswalle" 
//             className="fw-brand__logo1" 
//           />
//         </div>
//       <div className="fw-processing-new__content">

//         <h1 className="fw-title fw-processing-new__title">
//           Preparing Your
//           <br />
//           Personalized Loan Offer
//         </h1>

//         <p className="fw-sub fw-processing-new__sub">
//           We&apos;re currently reviewing your application to craft
//           the most suitable loan offer tailored to your financial
//           needs.
//         </p>

//         {/* Illustration */}
//         <div
//           className="fw-processing-new__art"
//           aria-hidden="true"
//         >
//           <div className="fw-processing-new__circle" />

//           <div className="fw-processing-new__dashboard">
//             <span className="dashboard-circle" />
//             <span className="dashboard-line dashboard-line--1" />
//             <span className="dashboard-line dashboard-line--2" />
//             <span className="dashboard-line dashboard-line--3" />
//           </div>

//           <div className="fw-processing-new__person">
//             <span className="person-head" />
//             <span className="person-body" />
//             <span className="person-leg person-leg--1" />
//             <span className="person-leg person-leg--2" />
//           </div>

//           <div className="fw-processing-new__magnifier">
//             <span />
//           </div>

//           <div className="fw-processing-new__hand">
//             <span className="hand-palm" />
//             <span className="hand-finger hand-finger--1" />
//             <span className="hand-finger hand-finger--2" />
//             <span className="hand-finger hand-finger--3" />
//           </div>

//           <div className="fw-processing-new__scan">
//             <span />
//             <span />
//             <span />
//           </div>
//         </div>

//         <h2 className="fw-processing-new__bank-title">
//           Process to Bank
//         </h2>

//         <p className="fw-processing-new__bank-text">
//           We&apos;ve received your employment details and are
//           securely sharing them with the bank. Once we review
//           your bank statement and complete our analysis, we&apos;ll
//           share a suitable offer with you.
//         </p>

//         <p className="fw-processing-new__hold">
//           Please hold while we complete the
//           <br />
//           necessary verification checks.
//         </p>

//       </div>

//       <div className="fw-screen__footer fw-processing-new__footer">
//         <button
//           type="button"
//           className="fw-btn fw-btn--dark fw-btn--full"
//           disabled={!ready}
//           onClick={() => setScreen("/apply-new/selectBank")}
//         >
//           {ready ? "Proceed to Bank" : "Proceed"}
//         </button>
//       </div>
//     </section>
//   );
// };

// export default ProcessingPage;

import React, { useEffect, useState } from "react";
import fundwalelogo from "../../assets/images/Fundswalle_Logo.png";

const ProcessingPage = ({
  setScreen,
  onProcess,
  onProceedToBank,
}) => {
  const [processing, setProcessing] = useState(true);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState("");

  const startProcessing = async () => {
    try {
      setProcessing(true);
      setReady(false);
      setError("");

      console.log("========== PROCESSING START ==========");

      // Credit Analytics API
      await onProcess();

      console.log("========== CREDIT VERIFICATION SUCCESS ==========");

      setReady(true);
    } catch (err) {
      console.error(
        "Credit Analytics / Processing error:",
        err
      );

      setError(
        err?.message ||
          "Unable to complete credit verification. Please try again."
      );

      setReady(false);
    } finally {
      setProcessing(false);
    }
  };

  useEffect(() => {
    startProcessing();
  }, []);

  return (
    <section className="fw-screen fw-screen--processing-new fw-fade">

      {/* Logo */}
      <div className="fw-brandmain2">
        <img
          src={fundwalelogo}
          alt="Fundswalle"
          className="fw-brand__logo1"
        />
      </div>

      {/* Content */}
      <div className="fw-processing-new__content">

        <h1 className="fw-title fw-processing-new__title">
          Preparing Your
          <br />
          Personalized Loan Offer
        </h1>

        <p className="fw-sub fw-processing-new__sub">
          We're currently reviewing your application to craft
          the most suitable loan offer tailored to your financial
          needs.
        </p>

        {/* Illustration */}
        <div
          className="fw-processing-new__art"
          aria-hidden="true"
        >
          <div className="fw-processing-new__circle" />

          <div className="fw-processing-new__dashboard">
            <span className="dashboard-circle" />
            <span className="dashboard-line dashboard-line--1" />
            <span className="dashboard-line dashboard-line--2" />
            <span className="dashboard-line dashboard-line--3" />
          </div>

          <div className="fw-processing-new__person">
            <span className="person-head" />
            <span className="person-body" />
            <span className="person-leg person-leg--1" />
            <span className="person-leg person-leg--2" />
          </div>

          <div className="fw-processing-new__magnifier">
            <span />
          </div>

          <div className="fw-processing-new__hand">
            <span className="hand-palm" />
            <span className="hand-finger hand-finger--1" />
            <span className="hand-finger hand-finger--2" />
            <span className="hand-finger hand-finger--3" />
          </div>

          <div className="fw-processing-new__scan">
            <span />
            <span />
            <span />
          </div>
        </div>

        {/* Heading */}
        <h2 className="fw-processing-new__bank-title">
          Credit Verification
        </h2>

        {/* Description */}
        <p className="fw-processing-new__bank-text">
          We're securely checking your credit profile and
          completing the necessary verification checks before
          proceeding with your bank verification.
        </p>

        {/* Processing / Success / Error */}
        {processing && !error && (
          <p className="fw-processing-new__hold">
            We're checking your credit profile.
            <br />
            Please hold while we complete the verification.
          </p>
        )}

        {!processing && ready && !error && (
          <p className="fw-processing-new__hold">
            Credit verification completed successfully.
            <br />
            You can now proceed to bank verification.
          </p>
        )}

        {error && (
          <p className="fw-error fw-processing-new__hold">
            {error}
          </p>
        )}

      </div>

      {/* Bottom Button */}
      <div className="fw-screen__footer fw-processing-new__footer">

        <button
          type="button"
          className="fw-btn fw-btn--dark fw-btn--full"
          disabled={processing}
          // onClick={() => {
          //   if (ready) {
          //     setScreen("/apply-new/selectBank");
          //   } else if (error) {
          //     startProcessing();
          //   }
          // }}
          onClick={() => {
  if (ready) {
    onProceedToBank();
  } else if (error) {
    startProcessing();
  }
}}
        >
          {processing
            ? "Verifying..."
            : error
            ? "Retry"
            : "Proceed to Bank"}
        </button>

 <button
    type="button"
    onClick={() => setScreen("/apply-new/referenceDetails")}
    style={{
      marginTop: "8px",
      padding: "7px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      background: "#fff",
      color: "#6b7280",
      fontSize: "11px",
      fontWeight: "600",
      cursor: "pointer",
    }}
  >
    TEMP: Go to Selfie
  </button>
      </div>



    </section>
  );
};

export default ProcessingPage;